export default __webpack_public_path__ + "static/media/enrutamiento.a65b3a9a.jpg";